<template>
  <div class="app-layout">
    <Navbar />

    <!-- Page Content -->
    <main class="main-content">
      <router-view />
    </main>

    <!-- Footer -->
    <footer class="footer-container">
      <div class="footer-content">
        <div class="footer-grid">
          <!-- Column 1: Brand -->
          <div class="footer-column">
            <div class="brand-section">
              <h2 class="logo">PhysioNepals</h2>
              <p class="tagline">
                Premium physiotherapy equipment and rehabilitation products for
                professionals in Nepal.
              </p>
              <div class="social-links">
                <a href="https://www.facebook.com/physio.nepal.2025" target="_blank" rel="noopener noreferrer"
                  aria-label="Facebook" class="social-link">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path
                      d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333H16V2.169c-.585-.089-1.308-.169-2.227-.169-2.753 0-4.773 1.236-4.773 3.53V8z" />
                  </svg>
                </a>
                <a href="https://www.tiktok.com/@physio_nepal" target="_blank" rel="noopener noreferrer"
                  aria-label="TikTok" class="social-link">
                  <!-- Simple TikTok icon (you can replace with better SVG if needed) -->
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path
                      d="M12.53.02C13.84 0 15.14.01 16.44.01c.08 1.53.63 3.09 1.81 4.13 1.09 1.01 2.57 1.35 3.95 1.3v2.94c-1.2.04-2.39-.34-3.37-1.07-.98-.73-1.73-1.84-2.07-3.05v7.46c0 4.06-3.3 7.36-7.36 7.36-1.03 0-2-.21-2.88-.59.82.7 1.87 1.12 3.02 1.12 4.06 0 7.36-3.3 7.36-7.36V.02zM5.41 19.09c-.99-.64-1.65-1.79-1.65-3.11 0-2.04 1.65-3.69 3.69-3.69.45 0 .88.08 1.28.23v-2.94c-.4-.07-.82-.11-1.24-.11-3.69 0-6.69 3-6.69 6.69 0 1.76.68 3.36 1.79 4.57z" />
                  </svg>
                </a>
                <a href="https://www.daraz.com.np/shop/rr-multilinks-suppliers/?spm=a2a0e.pdp_revamp.seller.1.23ac477d5RErps&itemId=506406532&channelSource=pdp"
                  target="_blank" rel="noopener noreferrer" aria-label="Daraz" class="social-link">
                  <!-- Daraz icon placeholder - use text or custom SVG -->
                  <span class="daraz-text">Daraz</span>
                </a>
                <a href="https://www.linkedin.com/in/kiran-thapa-b769b233a" target="_blank" rel="noopener noreferrer"
                  aria-label="LinkedIn" class="social-link">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path
                      d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>

          <!-- Column 2: Quick Links -->
          <div class="footer-column">
            <h3 class="column-title">Quick Links</h3>
            <nav class="footer-links">
              <router-link to="/" class="footer-link">Home</router-link>
              <router-link to="/categories" class="footer-link">Categories</router-link>
              <router-link to="/products" class="footer-link">Products</router-link>
              <router-link to="/about" class="footer-link">About Us</router-link>
            </nav>
          </div>

          <!-- Column 3: Information -->
          <div class="footer-column">
            <h3 class="column-title">Information</h3>
            <nav class="footer-links">
              <a href="#" class="footer-link">Privacy Policy</a>
              <a href="#" class="footer-link">Terms & Conditions</a>
              <a href="#" class="footer-link">Shipping Info</a>
              <a href="#" class="footer-link">FAQs</a>
            </nav>
          </div>

          <!-- Column 4: Contact -->
          <div class="footer-column">
            <h3 class="column-title">Contact Us</h3>
            <div class="contact-info">
              <a href="tel:+9779801983833" class="contact-link">
                <span class="icon">☎</span>
                980-1983833
              </a>
              <a href="mailto:kiranthapa@physionepal.com.np" class="contact-link">
                <span class="icon">✉</span>
                kiranthapa@physionepal.com.np
              </a>
              <div class="contact-link">
                <span class="icon">📍</span>
                Gaidakot - 04, Nawalparasi
              </div>
            </div>

            <!-- Google Maps Embed -->
            <div class="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3532.476833619416!2d84.41439277546723!3d27.702560176185237!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3994fbff10f34819%3A0x36af9a8388d96ed9!2sPhysio%20Nepal%20Surgical%20House!5e0!3m2!1sen!2snp!4v1771555387316!5m2!1sen!2snp"
                width="100%" height="200" style="border:0;" allowfullscreen="" loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
          </div>
        </div>

        <!-- Footer Bottom -->
        <div class="footer-bottom">
          <p class="copyright">© 2026 PhysioNepals. All rights reserved.</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import Navbar from "@/components/NavSection.vue";

export default {
  name: "MainLayout",
  components: {
    Navbar,
  },
};
</script>

<style scoped>
/* ── Existing styles ──────────────────────────────────────────────────────── */
/* ... keep all your previous styles ... */

/* Add these new/updated styles */

.social-links {
  display: flex;
  gap: 1rem;
  margin-top: 0.5rem;
}

.social-link {
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.1);
  color: #7ed9b0;
  transition: all 0.3s cubic-bezier(0.23, 1, 0.320, 1);
  text-decoration: none;
  font-size: 1.1rem;
}

.social-link:hover {
  background-color: #7ed9b0;
  color: #0f4c3a;
  transform: translateY(-2px);
}

.daraz-text {
  font-size: 0.9rem;
  font-weight: bold;
}

.map-container {
  margin-top: 1.5rem;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.map-container iframe {
  display: block;
}

/* Responsive adjustments */
@media (max-width: 1024px) {
  .footer-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 640px) {
  .footer-grid {
    grid-template-columns: 1fr;
  }

  .map-container {
    height: 180px;
  }
}
</style>


<style scoped>
.app-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #fafafa;
}

.main-content {
  flex: 1;
  width: 100%;
  padding: 2rem;
}

/* Footer Styles */
.footer-container {
  width: 100%;
  background: linear-gradient(135deg, #0f4c3a 0%, #1a6b52 100%);
  color: #ffffff;
  margin-top: 4rem;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 3rem 1.5rem 2rem;
}

.footer-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  margin-bottom: 2rem;
}

.footer-column {
  display: flex;
  flex-direction: column;
}

.brand-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.logo {
  font-size: 1.75rem;
  font-weight: 700;
  color: #7ed9b0;
  margin: 0;
  letter-spacing: -0.02em;
}

.tagline {
  font-size: 0.95rem;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
}

.social-links {
  display: flex;
  gap: 1rem;
  margin-top: 0.5rem;
}

.social-link {
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.1);
  color: #7ed9b0;
  transition: all 0.3s cubic-bezier(0.23, 1, 0.320, 1);
  text-decoration: none;
}

.social-link:hover {
  background-color: #7ed9b0;
  color: #0f4c3a;
  transform: translateY(-2px);
}

.social-link svg {
  width: 1.2rem;
  height: 1.2rem;
}

.column-title {
  font-size: 1rem;
  font-weight: 600;
  color: #7ed9b0;
  margin: 0 0 1rem 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.footer-links {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.footer-link {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  font-size: 0.95rem;
  transition: color 0.3s ease;
  display: inline-block;
}

.footer-link:hover {
  color: #7ed9b0;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.contact-link {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  font-size: 0.95rem;
  transition: color 0.3s ease;
}

.contact-link:hover {
  color: #7ed9b0;
}

.contact-link .icon {
  font-size: 1.2rem;
  flex-shrink: 0;
  margin-top: 0.1rem;
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 1.5rem;
  text-align: center;
}

.copyright {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.9rem;
  margin: 0;
}

@media (max-width: 1024px) {
  .footer-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
  }
}

@media (max-width: 640px) {
  .main-content {
    padding: 1rem;
  }

  .footer-content {
    padding: 2rem 1rem 1.5rem;
  }

  .footer-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .logo {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }

  .tagline {
    font-size: 0.9rem;
  }

  .column-title {
    font-size: 0.95rem;
    margin-bottom: 0.75rem;
  }

  .footer-link,
  .contact-link {
    font-size: 0.9rem;
  }

  .copyright {
    font-size: 0.85rem;
  }
}

@media (max-width: 480px) {
  .main-content {
    padding: 0.75rem;
  }

  .footer-container {
    margin-top: 2rem;
  }

  .footer-content {
    padding: 1.5rem 0.75rem 1rem;
  }

  .logo {
    font-size: 1.35rem;
  }

  .tagline {
    font-size: 0.85rem;
    line-height: 1.5;
  }

  .social-links {
    gap: 0.75rem;
  }

  .social-link {
    width: 2.2rem;
    height: 2.2rem;
  }

  .social-link svg {
    width: 1rem;
    height: 1rem;
  }

  .footer-links {
    gap: 0.6rem;
  }

  .contact-info {
    gap: 0.8rem;
  }
}
</style>